module.exports = __webpack_public_path__ + "static/media/dad.23b947a7.jpeg";